export default __webpack_public_path__ + "static/AIAGC_EXHB_1-6074d67d5b1e20c4a1a94f1df408e5ca.jpg";